export class FuncionarioPesquisaFiltros {

  advogado: boolean;
  funcionario: boolean;
  estagiario: boolean;
  assistenteJuridico: boolean;
  parceiro: boolean;
  adovgadoParceiro: boolean;
  buscaTexto: string;
  buscaTipo: string;
  tipo: any;
  ativo: string;

  constructor() {
    this.ativo = 'A';
    this.advogado = true;
    this.funcionario = true;
    this.estagiario = false;
    this.assistenteJuridico = false;
    this.parceiro = false;
    this.adovgadoParceiro = false;
    this.buscaTexto = '';
    this.buscaTipo = 'NOME';
    this.tipo = [{ value: 'CNPJ_CPF', nome: 'CNPJ_CPF' },
    { value: 'NOME', nome: 'Nome' },
    { value: 'OAB', nome: 'OAB' }
    ];
  }

}
